import React, { useState, useRef, useEffect } from 'react';
import useBodyScrollLock from '../../../../hooks/useBodyScrollLock';
import { useDispatch, useSelector } from 'react-redux';
import { updateMainFilter } from '../../mainFilterSlice';
import { t } from '../../../../utilities/translator';
import { scrollToResults, findInArray, isMobile } from '../../../../utilities/helpers';
import FadeTransition from '../../../../components/animations/FadeTransition';
import {
  setLastChangedFilter,
  selectFromWhereHompageActiveId,
  setFromWhereHompageActiveId,
  selectAppState,
} from '../../../../appSlice';
import FilterModal from './FIlterModal';
import DepartureList from './DepartureList';
import LoginBlock from '../../../user/LoginBlock';
import { selectFilterData } from '../../selectors';
// import { selectUser } from '../../../user/userSlice';
import { selectSecondaryFilter } from '../../../secondaryFilter/secondaryFilterSlice';
import { pushEvent } from '../../../../utilities/analytics';
import api from '../../../../api';
import {
  ENGINE_ORIGIN_OPENED,
  ENGINE_ORIGIN_APPLIED,
  AIRPORT_CONTINUE,
  AIRPORT_SAVE,
  OPEN_LOGIN_BLOCK,
  CLOSE_LOGIN_BLOCK,
  MAYBELATER_LOGIN_BLOCK,
} from '../../../../constants/analyticEvents';

const DepartureMultiSelect = () => {
  const ref = useRef();
  const dispatch = useDispatch();
  const {
    searchEngine: { fromwhere: departures, from_where_groups: fromWhereGroups },
  } = useSelector(selectFilterData);
  const { showResults } = useSelector(selectAppState);
  const fromWhereHomepageActiveId = useSelector(selectFromWhereHompageActiveId);
  const secondaryFilter = useSelector(selectSecondaryFilter);
  const mainFilter = useSelector(selectFilterData);
  const userContext = JSON.parse(localStorage.getItem('hf_user')); // useSelector(selectUser);
  const [showModal, setShowModal] = useState(false);
  const lastChangedFilter = useSelector(state => state.app.lastChangedFilter);
  const depNotSet = !((userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth && userContext?.user?.originAirports?.length) || localStorage.getItem('selectedFromwhere') || window.location.href.indexOf('fromwhere') > -1);
  let defaultSelectedDep = [...departures];
  if (depNotSet) {
    defaultSelectedDep = defaultSelectedDep.map(dep => ({
      ...dep,
      active: false
    }));
  }
  const [selectedDepartures, setSelectedDepartures] = useState(defaultSelectedDep);
  const selectedPrev = departures.filter(dp => dp.active);
  const userIsNotNew = !!((userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth && userContext?.user?.originAirports?.length) || localStorage.getItem('selectedFromwhere') || sessionStorage.getItem('fromWhereOpened'));

  // const loginWasClosed = +localStorage.getItem('loginClosed');
  const [isLoginOpen, setLoginOpen] = useState(false);
  // const [showLoginBtn, setShowLoginBtn] = useState(!((loginWasClosed > Date.now()) || (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth)));
  const [showLoginBtn, setShowLoginBtn] = useState(!(userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth));
  const loginTriggerTxt = "Departure airports filter";

  useBodyScrollLock({ condition: showModal, mobileOnly: false });

  /* useEffect(() => {
    setShowLoginBtn(!((loginWasClosed > Date.now()) || (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth)));
  }, [loginWasClosed, userContext]); */

  useEffect(() => {
    if (!(userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) && showModal && !showLoginBtn) {
      setShowLoginBtn(true);
    }
  }, [userContext?.user?.userLevel, userContext?.user?.user_auth, showModal]);

  useEffect(() => {
    if (showModal) {
      pushEvent(ENGINE_ORIGIN_OPENED);
      if (!sessionStorage.getItem('fromWhereOpened')) {
        sessionStorage.setItem('fromWhereOpened', 1);
      }
      document.getElementById('app').classList.add('fromwherePopup-opened');
    } else {
      document.getElementById('app').classList.remove('fromwherePopup-opened');
    }
  }, [showModal]);

  useEffect(() => {
    if (fromWhereHomepageActiveId && fromWhereHomepageActiveId.length && window.location.href.indexOf('fromwhere') === -1) {
      const newSelectedDeparture = selectedDepartures.map(dep => {
        return {
          ...dep,
          active: findInArray(fromWhereHomepageActiveId, dep.id)
        };
      });
      setSelectedDepartures(newSelectedDeparture);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromWhereHomepageActiveId]);

  useEffect(() => {
    if (fromWhereHomepageActiveId && fromWhereHomepageActiveId.length && lastChangedFilter && lastChangedFilter !== 'fromwhere') {
      const updatedDepartures = departures.map((departure) => ({
        ...departure,
        active: findInArray(fromWhereHomepageActiveId, departure.id),
      }));
      dispatch(setFromWhereHompageActiveId([]));
      dispatch(updateMainFilter({ filter: 'fromwhere', updatedValue: updatedDepartures }));
      dispatch(setLastChangedFilter('fromwhere'));
      scrollToResults();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryFilter.data, mainFilter.searchEngine, lastChangedFilter]);

  const onOpenLogin = () => {
    setLoginOpen(true);
    // eslint-disable-next-line no-undef
    if (typeof closeSubscribeLogin !== 'undefined') {
      // eslint-disable-next-line no-undef
      closeSubscribeLogin();
    }
    pushEvent(AIRPORT_SAVE, { departures: selectedDepartures });
    pushEvent(OPEN_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginPopupClose = () => {
    // const tomorrow = new Date(); // it seems that it's not needed here
    // tomorrow.setDate(tomorrow.getDate() + 1);
    setLoginOpen(false);
    setShowLoginBtn(false);
    // localStorage.setItem('loginClosed', +tomorrow);
    pushEvent(CLOSE_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginPopupCloseLater = () => {
    setLoginOpen(false);
    setShowLoginBtn(false);
    pushEvent(MAYBELATER_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginPopupCloseLogIn = () => {
    setLoginOpen(false);
    setShowLoginBtn(false);
  };

  useEffect(() => {
    window.addEventListener('userLoggedIn', loginPopupCloseLogIn);

    return () => {
      window.removeEventListener('userLoggedIn', loginPopupCloseLogIn);
    };
  }, []);

  const onSave = () => {
    if (isMobile() && showLoginBtn) {
      onOpenLogin();
      return true;
    }
    // Save origin airports data
    // set selected fromWhere to the localStorage for the further pre-selecting
    const selectedFromwhere = selectedDepartures.filter((item) => item.active);
    const selectedIds = selectedFromwhere.map(item => item.id);
    const fromwhereEndDate = new Date();
    fromwhereEndDate.setDate(fromwhereEndDate.getDate() + 365);
    localStorage.setItem(
      'selectedFromwhere',
      JSON.stringify({ fromwhere: selectedFromwhere, date: fromwhereEndDate.getTime() })
    );

    if (showResults) {
      dispatch(updateMainFilter({ filter: 'fromwhere', updatedValue: selectedDepartures }));
      dispatch(setLastChangedFilter('fromwhere'));
      scrollToResults();
    } else {
      dispatch(setFromWhereHompageActiveId(selectedIds));
    }

    setShowModal(false);

    if (userContext && userContext.user) {
      const newUserContext = { ...userContext };
      newUserContext.user.originAirports = selectedIds;
      api.updateContextWithDeparture(newUserContext);
    }

    pushEvent(ENGINE_ORIGIN_APPLIED, {
      activeDeparture: selectedFromwhere,
      previousDeparture: selectedPrev,
      type: 'save',
    });
    pushEvent(AIRPORT_CONTINUE, {
      activeDeparture: selectedFromwhere
    });
  };

  const onClear = () => {
    // clear fromWhere filter TODO: clarify if this is right functionality
    let newSelectedDeparture = selectedDepartures.map((dep, i) => {
      return {
        ...dep,
        active: dep.ip_selected || false
      };
    });
    const savedFromWhere = JSON.parse(localStorage.getItem('selectedFromwhere'));
    if (savedFromWhere && savedFromWhere.date > new Date().getTime() && savedFromWhere.fromwhere.length) {
      const savedFromIds = savedFromWhere.fromwhere.map(dep => dep.id);
      newSelectedDeparture = selectedDepartures.map((dep, i) => {
        return {
          ...dep,
          active: findInArray(savedFromIds, dep.id)
        };
      });
    }
    if (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth && userContext?.user?.originAirports?.length) {
      newSelectedDeparture = selectedDepartures.map((dep, i) => {
        return {
          ...dep,
          active: findInArray(userContext.user.originAirports, dep.id)
        };
      });
    }
    setSelectedDepartures(newSelectedDeparture);

    if (showResults) {
      dispatch(updateMainFilter({ filter: 'fromwhere', updatedValue: newSelectedDeparture }));
      dispatch(setLastChangedFilter('fromwhere'));
      scrollToResults();
    } else {
      const selectedIds = newSelectedDeparture.filter(d => d.active).map(item => item.id);
      dispatch(setFromWhereHompageActiveId(selectedIds));
    }

    setShowModal(false);

    pushEvent(ENGINE_ORIGIN_APPLIED, {
      activeDeparture: newSelectedDeparture,
      previousDeparture: selectedPrev,
      type: 'clear',
    });
  };

  const onClose = () => {
    setShowModal(false);
    const newSelectedDeparture = [...departures];
    setSelectedDepartures(newSelectedDeparture);
  };

  const handleCheckbox = (airportCode) => {
    const newSelectedDeparture = selectedDepartures.map(dep => {
      return {
        ...dep,
        active: (airportCode === dep.id) ? !dep.active : dep.active
      };
    });
    setSelectedDepartures(newSelectedDeparture);
  };

  const handleCheckboxGroup = (group, value) => {
    const newSelectedDeparture = selectedDepartures.map(dep => {
      return {
        ...dep,
        active: (dep.group_id === group) ? value : dep.active
      };
    });
    setSelectedDepartures(newSelectedDeparture);
  }

  const loginBtn = () => {
    if (typeof openLoginModal !== 'undefined') {
      // eslint-disable-next-line no-undef
      openLoginModal("Departure airports popup");
    } else {
      window.jQuery('#loginModal').modal('show');
    }
    setShowModal(false);
  };

  const footerBlock = () => {
    if (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) {
      return '';
    }
    return (
      <div className="fmf-block flex items-center gap-2">
        <i />
        <span className="fmfb-txt"><span className="fmf-login" onClick={loginBtn}>{t('mainFilter.login')}</span> {t('mainFilter.to_save_preferences')}</span>
      </div>
    );
  };

  const getAirportsLabel = () => {
    const selected = selectedDepartures.filter(({ active }) => active);

    if (!userIsNotNew || selected.length === 0) {
      return t('mainFilter.airport_preferences');
    }
    if (selected.length === 1) {
      return selected[0].value;
    }

    return t('mainFilter.airport_preferences_selected', { departure: selected[0].value, count: selected.length -1 });
  }

  return (
    <div className="departing" ref={ref}>
      <div className="departure-selector flex items-center">
        <div className="ds-lft flex gap-2 items-center">
          <i className="ri-flight-takeoff-line" />
          <span>{getAirportsLabel()}</span>
        </div>
        <div className="ds-btn flex gap-1 items-center" onClick={() => setShowModal(true)}>
          {!userIsNotNew && <i className="ri-error-warning-line" />}
          {
            userIsNotNew
              ? <span>{t('mainFilter.edit')}</span>
              : <span>{t('mainFilter.setup')}</span>
          }
        </div>
      </div>
      <FadeTransition
        in={showModal}
        unmountOnExit
      >
        <FilterModal
          title={t('mainFilter.departing_airport_preferences')}
          titleIconClass="ri-flight-takeoff-line"
          footerTxt={footerBlock()}
          saveBtnTxt={isMobile() ? t('buttons.Save') : t('onboarding.continue')}
          onClose={onClose}
          onSave={onSave}
          onClear={onClear}
          disableSave={!selectedDepartures.filter(item => item.active).length}
          showSaveLogin={showLoginBtn}
          onSaveLogin={onOpenLogin}
          className="departure-select-modal"
        >
          <DepartureList
            departures={selectedDepartures}
            fromWhereGroups={fromWhereGroups}
            handleCheckbox={handleCheckbox}
            handleCheckboxGroup={handleCheckboxGroup}
          />
          {!(userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) &&
            <LoginBlock
              className="login-block-departure"
              onClose={loginPopupClose}
              onCloseLater={loginPopupCloseLater}
              isOpen={isLoginOpen}
              type="departure"
              sourceBlock={loginTriggerTxt}
            />
          }
        </FilterModal>
      </FadeTransition>
    </div>
  );
}

export default React.memo(DepartureMultiSelect);
